import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const getReplenishmentReportViewCounts = {
  name: "getReplenishmentReportViewCounts" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    search: z.string().nullish(),
  }),
  output: z.object({ viewCounts: z.record(z.string(), z.number()) }),
};
